import { Box, Typography } from '@mui/material'
import SvgIconSize from './SvgIconSize';

const TitleWithIcon = ({
  title, icon, iconColor, customStyle, onClick, iconSize, textVariant,
}) => (
  <Box sx={[styles.root, customStyle]} onClick={onClick}>
    <Box sx={styles.iconContainer}>
      {icon && <SvgIconSize iconColor={iconColor} size={iconSize} icon={icon} />}
    </Box>
    <Typography variant={textVariant || 'p'} className="title" sx={styles.titleStyle}>
      {title}
    </Typography>
  </Box>
)

const styles = {
  root: {
    display: 'flex',
    alignItems: 'center',
    marginRight: '15px',
  },
  titleStyle: {
    textTransform: 'capitalize',
  },
  iconContainer: {
    marginRight: '5px',

    '& .material-icons': {
      overflow: 'unset',
      minWidth: 'min-content',
    },

    '& svg': {
      fontSize: '20px',
    },
  },
}
export default TitleWithIcon
